/* eslint-disable no-console */
//
// https://www.webnoob.dev/articles/turn-your-vue-web-app-into-a-pwa
// https://dev.to/drbragg/handling-service-worker-updates-in-your-vue-pwa-1pip
//
import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB',
      )
    },
    registered () {
      console.log('Service worker has been registered.')
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updatefound () {
      //* alert('Upgrading! wait while reload')
      console.log('New content is downloading.')
    },
    updated (registration) {
      console.log('New content is available; please refresh.')
      console.log(registration)
      // https://stackoverflow.com/questions/54145735/vue-pwa-not-getting-new-content-after-refresh

      // * window.location.reload(true)

      // registration.update()

      // caches.keys().then(function (names) {
      //   for (var name of names) caches.delete(name)
      // })
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      alert('Error during service worker registration')
      console.error('Error during service worker registration:', error)
    },
  })
}
